import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { User, UserDetail } from '../models/user.model';
import { ApiResponse, PageableApiResponse } from '../../api-response';
import { BaseApiService } from '../../../core/base-api.service';

@Injectable({
  providedIn: 'root'
})
export class UserManagementService extends BaseApiService {
  private readonly http = inject(HttpClient);
  private readonly userManagementBaseUrl = `${this.coreApiUrl}/api/v1/users`;

  getUsers(page: number, size: number, sortBy: string = 'email', sortDirection: 'ASC' | 'DESC' = 'ASC'): Observable<PageableApiResponse<User>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', `${sortBy},${sortDirection}`);

    return this.http.get<PageableApiResponse<User>>(this.userManagementBaseUrl + '/me/users', { params });
  }

  /** Envelope unwrapped here at the boundary — consumers get the flat UserDetail. */
  getUserById(id: string): Observable<UserDetail> {
    return this.http
      .get<ApiResponse<UserDetail>>(`${this.userManagementBaseUrl}/${id}`)
      .pipe(map((response) => response.data));
  }

  createUser(userData: {
    email: string;
    firstName: string;
    lastName: string;
    organizationIds: string[];
  }): Observable<User> {
    return this.http.post<User>(this.userManagementBaseUrl, userData);
  }
}
